import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MainImageCardDashboard from '../../../components/Cards/MainImageCardDashboard';
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import { cancer } from "../../../constants";


export default function CancerCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Cancer Prevention'} /> }

        iconbuttons = {<>               

                        <Tooltip title="Cancer Prevention" placement="bottom">
                                <IconButton component={RouterLink} to="/CancerWelcome"  size="large">
                                        <CoronavirusIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { cancer }  

    />

</>
)};
